import Link from "next/link";
import { FC } from "react";

import Container from "@components/Container";
import GlobeIcon from "@components/GlobeIcon";
import MailIcon from "@components/MailIcon";

interface Props {
  hideLinks?: boolean;
}

const Footer: FC<Props> = ({ hideLinks = false }) => {
  return (
    <>
      <div className="Footer">
        <div className="links">
          {!hideLinks && (
            <Container>
              <div className="link-items">
                <div style={{ flex: 1 }}>
                  <GlobeIcon />
                  {` `}
                  <a href="https://publicsafetycadets.org">www.publicsafetycadets.org</a>
                </div>
                <div style={{ flex: 0 }}>
                  <ul className="link-list">
                    <li>
                      <MailIcon />
                      {` `}
                      <a href="mailto:youthtraining@publicsafetycadets.org">
                        youthtraining@publicsafetycadets.org
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Container>
          )}
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .Footer {
          }

          .Footer a {
            color: #f8cb00;
            text-decoration: none;
          }

          .links {
            background-color: #0a0b0d;
            font-size: 0.9rem;
            min-height: 15px;
          }

          .link-list {
            padding: 0;
            margin: 0;
            list-style-type: none;
            align-items: center;
          }

          .link-list li {
            margin: 0;
            white-space: nowrap;
            height: 30px;
          }

          .sub-footer {
            margin: 20px 0;
            display: flex;
            line-height: 1.5;
            font-size: 11px;
          }

          .sub-section-1 {
            flex: 0;
            margin: 0 20px 0 0;
          }

          .sub-section-2 {
            font-family: Lato, Regular, "Helvetica Neue", Helvetica, Arial, sans-serif;
            flex: 1;
          }

          @media screen and (min-width: 1024px) {
            .link-items {
              display: flex;
            }

            .link-list {
              display: flex;
            }

            .link-list li {
              height: auto;
              margin: 0 0 0 20px;
            }
          }
        `}
      </style>
    </>
  );
};

export default Footer;
